/**
 * 이름 마스킹 (예: 김철수 → 김*수, 이영 → 이*, 홍 → 홍)
 * 스토어 서버에는 원본 환자 이름을 보내지 않고 이 값만 스냅샷으로 남긴다.
 */
export const maskName = (name: string): string => {
  const trimmed = name.trim();
  if (trimmed.length <= 1) {
    return trimmed;
  }
  if (trimmed.length === 2) {
    return `${trimmed[0]}*`;
  }
  return `${trimmed[0]}${"*".repeat(trimmed.length - 2)}${trimmed[trimmed.length - 1]}`;
};
